import Api from '@/services/Api'

export default {
  register (data) {
    return Api().post('/cp/register', data)
  },
  social (data) {
    return Api().post('/cp/register', data)
  },
  verify (data) {
    return Api().post('/cp/verify', data)
  },
  login (data) {
    return Api().post('/cp/login', data)
  },
  facebook (data) {
    return Api().post('/cp/facebook', data)
  },
  reset (data) {
    return Api().post('/cp/reset', data)
  },
  terms (data) {
    return Api().get('/cp/terms', data)
  },
  google (data) {
    return Api().post('/cp/google', data)
  },
  googleUrl () {
    return Api().get('/cp/google/url')
  },
  twitterUrl (data) {
    return Api().get('/cp/twitter/url?vendor=' + data.vendor)
  },
  twitter (data) {
    return Api().post('/cp/twitter', data)
  },
  linkedIn (data) {
    return Api().post('/cp/linkedIn', data)
  }
}



// WEBPACK FOOTER //
// ./src/services/AuthService.js